import { ICoursesFilters } from '@sdk/contracts';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAllCoursesForSelectors } from '@/store';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  styles?: React.CSSProperties;
  mode?: 'multiple' | 'tags';
  filters?: ICoursesFilters;
  allowClear?: boolean;
};

export const CourseSelector: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  styles,
  mode,
  filters,
  allowClear = false
}) => {
  const { t } = useTranslation();
  const { courses = [] } = useAllCoursesForSelectors(filters);

  const options = courses.map(c => ({ label: c.name, value: c._id }));

  return (
    <Select
      mode={mode}
      showSearch
      allowClear={allowClear}
      style={styles}
      options={options}
      onChange={onChange}
      value={value}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      placeholder={placeholder ?? t('SELECT_COURSE')}
    />
  );
};
